export class CompleteTheLook extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.manageOwlCarousel = this.manageOwlCarousel.bind(this)

    this.listeners.add(window, 'resize', this.manageOwlCarousel)
    this.manageOwlCarousel()
    this.setupHoverUpdates()
  }

  setupHoverUpdates () {
    const productCards = this.els.product.elements
    const titleElement = this.els.title.element
    const priceElement = this.els.price.element

    productCards.forEach(card => {
      this.listeners.add(card, 'mouseover', (event) => {
        titleElement.innerHTML = card.dataset.title
        priceElement.innerHTML = card.dataset.price
      })

      this.listeners.add(card, 'mouseout', (event) => {
        titleElement.innerHTML = titleElement.dataset.title
        priceElement.innerHTML = ''
      })
    })
  }

  initializeGallery(carousel) {
    if (typeof jQuery !== 'undefined' && carousel) {
      $(carousel.selector).owlCarousel({
        items: parseInt(carousel.element.dataset.items) || 1,
        loop: carousel.element.dataset.loop === 'true',
        margin: 10,
        nav: carousel.element.dataset.nav === 'true',
        navText: ["<span class=\"visually-hidden\"></span><i class=\"la la-angle-left\"></i>", "<span class=\"visually-hidden\"></span><i class=\"la la-angle-right\"></i>"],
        dots: carousel.element.dataset.dots === 'true',
        navContainer: '.sec-CompleteTheLook_CarouselNav',
      })
    } else {
      console.error('jQuery or OwlCarousel not loaded.', typeof jQuery, carousel)
    }
  }

  destroyGallery(carousel){
    $(carousel.selector).trigger('destroy.owl.carousel')
  }

  manageOwlCarousel() {
    if ($(window).width() > 768) {
      this.destroyGallery(this.els?.carousel)
    } else {
      this.initializeGallery(this.els?.carousel)
    }
  }

  toTitleCase(str) {
    return str
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')
  }
}

customElements.define('complete-the-look', CompleteTheLook)